export function formatNum (val, exponent = 2) {
  if (!val) {
    return val
  }
  const result = Math.pow(10, exponent)
  let value = Math.floor(Number(val) * result) / result
  value = String(value)
  const reg = value?.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  value = value.replace(reg, '$1,')
  return value
}
